import { render } from "./PhoneTypeComponent.vue?vue&type=template&id=ad699312&scoped=true"
import script from "./PhoneTypeComponent.vue?vue&type=script&lang=js"
export * from "./PhoneTypeComponent.vue?vue&type=script&lang=js"

import "./PhoneTypeComponent.vue?vue&type=style&index=0&id=ad699312&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad699312"]])

export default __exports__